<script>
import Page from '~/pages/_lang/index/index.vue'
export default Page
</script>
